module.exports = __webpack_public_path__ + "img/coding.c54ab964.svg";